import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TArrow } from './models';

export const FullHeightArrow: FC<TArrow> = ({
    ArrowIcon,
    Button,
    btnDisabled,
    direction,
    onClick,
    styles,
}) => (
    <Button
        dataTestId={`${direction}-full-height-arrow`}
        hasAnimation={false}
        innerClassName={cn(styles.button, styles.external, styles[direction], {
            [styles.hidden]: btnDisabled,
        })}
        onClick={onClick}
    >
        <ArrowIcon className={cn(styles.icon, styles[direction])} />
    </Button>
);
